import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Observable, map, startWith, switchMap } from 'rxjs';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { InputPreDirective } from 'src/app/shared-extra/directives/input-pre.directive';
import { SvgComponent } from 'src/app/shared/components/svg/svg.component';
import { AutofocusDirective } from 'src/app/shared/directives/autofocus.directive';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { InputFieldComponent } from '../../../../shared-extra/components/input-field/input-field.component';
import { ConversionFormat } from '../../templates/conversion-template/conversion-template.component';
import { ConversionFormatSelectMenuItemComponent } from '../conversion-format-select-menu-item/conversion-format-select-menu-item.component';

@Component({
  selector: 'app-conversion-format-select-menu-content',
  standalone: true,
  templateUrl: './conversion-format-select-menu-content.component.html',
  styleUrls: ['./conversion-format-select-menu-content.component.scss'],
  imports: [
    CommonModule,
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    ButtonDirective,
    SvgComponent,
    InputFieldComponent,
    InputPreDirective,
    AutofocusDirective,
    ConversionFormatSelectMenuItemComponent,
  ],
})
export class ConversionFormatSelectMenuContentComponent {
  @Input({ required: true }) mode: 'from' | 'to';
  @Input() fromFormat: ConversionFormat;
  @Input() toFormat: ConversionFormat;
  @Input() linkMode: boolean;
  @Input() simpleMode: boolean;
  @Output() formatSelected = new EventEmitter<ConversionFormat>();
  private storyblokService = inject(StoryblokService);
  form = new FormGroup({
    search: new FormControl(''),
  });

  formats$: Observable<ConversionFormat[]> = this.form.valueChanges.pipe(
    startWith({ search: '' }),
    switchMap(({ search }) =>
      this.storyblokService.getStories({ content_type: 'ImageFormat' }).pipe(
        map((formats: ConversionFormat[]) => {
          if (this.mode === 'to') {
            return formats.filter(format => !(format as ConversionFormat).content.sourceOnly);
          }
          return formats;
        }),
        map(formats => {
          const results = formats.filter(format => format.name.toLowerCase().includes(search.toLowerCase()));
          results.sort((a, b) => a.name.localeCompare(b.name));
          return results;
        })
      )
    )
  );

  popularFormats$ = this.formats$.pipe(
    map(formats => {
      return formats.filter(format => format.content.isPopular);
    })
  );
}
